import React, { useState } from "react";
import api from "../api"; 
import { toast } from "react-toastify";

const EmailTestPage = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Please enter an email address.");
      return;
    }

    setLoading(true);

    try {
      // ✅ UPDATED: Use 'api.post' instead of 'axios.post'
      // The 'api' instance already knows the Base URL, so we just pass the endpoint path.
      // Make sure the endpoint matches your backend controller.
      const response = await api.post("/vres/public/test-email", {
        email: email,
      });

      // Check success based on your backend response structure
      if (response.data && response.data.success) {
        toast.success(response.data.message || "Test email sent!");
        setEmail(""); 
      } else {
        // Fallback if success flag is missing but request didn't fail
        toast.success("Request sent successfully!"); 
        setEmail("");
      }
    } catch (err) {
      console.error("Test email error:", err);
      const msg = err.response?.data?.message || "Error calling email API.";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container" style={{ display: 'flex', justifyContent: 'center', marginTop: '50px' }}>
      <div className="card" style={{ maxWidth: '400px', width: '100%', padding: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>Test Email Service</h2>
        <p style={{ textAlign: "center", marginBottom: "20px", color: "#666" }}>
          Enter an email address to test Brevo integration.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="form-group" style={{ marginBottom: "15px" }}>
            <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Email Address</label>
            <input
              type="email"
              className="form-control"
              placeholder="name@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ width: '100%', padding: '10px', boxSizing: 'border-box' }}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            disabled={loading}
            style={{ width: '100%', padding: '10px', cursor: loading ? 'not-allowed' : 'pointer' }}
          >
            {loading ? "Sending..." : "Test Email"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EmailTestPage;